export const PREVIEWABLE_FILE_EXTENSIONS = ['png', 'jpg', 'jpeg'];

export const isPreviewableExtension = (extension: string) =>
  PREVIEWABLE_FILE_EXTENSIONS.includes(extension.toLowerCase());
